export const DEFAULT_TIMEZONE = "America/Los_Angeles";

export const DEFAULT_CLOCK_IN_BONUS_POINTS = 5;
